import _Box from "@mui/material/Box";
import _Divider from "@mui/material/Divider";
import React from 'react';
import { fakeEmployees } from '../../challenge-leaderboard';
import LeaderboardIndividualItem from './item';
function FakeEmployees({
  FakeItemsCard,
  event,
  freeOfferEmployeesLeaderboardsMaxRowsCount
}) {
  return /*#__PURE__*/React.createElement(_Box, {
    sx: {
      position: 'relative'
    }
  }, fakeEmployees.map((user, index) => {
    const rank = freeOfferEmployeesLeaderboardsMaxRowsCount + 2;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(_Divider, {
      sx: {
        borderColor: '#dde0e7'
      }
    }), /*#__PURE__*/React.createElement(LeaderboardIndividualItem, {
      blurred: true,
      challengeType: event.challengeTemplate?.type,
      item: {
        user,
        rank,
        leaderboardIndex: rank + index,
        progressValue: 0
      },
      prevItemRank: freeOfferEmployeesLeaderboardsMaxRowsCount + 1
    }));
  }), /*#__PURE__*/React.createElement(FakeItemsCard, {
    isEventWithOffer: event
  }));
}
export default FakeEmployees;